// src/pages/mission.js
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import './mission.css';

const Mission = () => {
  return (
    <div className="mission-page-container app-content">
      <Navbar />

      <section className="about-mission">
        <div className="about-grid">
          <motion.div
            className="about-image"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <img
              src="/logo_motion.gif"
              alt="Animated representation"
            />
          </motion.div>

          <motion.div
            className="about-content"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, amount: 0.2 }}
          >
            <h2>Our Mission</h2>
            <div className="underline"></div>
            <p>At Sapiencia.AI, our mission is to harness the power of artificial intelligence to solve critical security challenges for healthcare providers and defense agencies. We are dedicated to developing AI solutions that protect sensitive information, enhance operational efficiency, and ultimately save lives.</p>
            <p>Founded by a team of security experts and AI researchers, we bring together deep technical expertise with a profound understanding of the unique requirements of federal agencies and healthcare organizations.</p>
          </motion.div>
        </div>
      </section>

      <section className="capabilities-download">
        <div className="capabilities-inner">
          <h2>Discover Our Full Capabilities</h2>
          <p>Click below to download our Capabilities Statement</p>
          <a
            href="/Sapiencia_Cap_Statement.pdf"
            download
            className="download-button"
          >
            Download Capabilities Statement
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Mission;
